// extracted by mini-css-extract-plugin
export default {"videoLouncher":"Campaigns_videoLouncher__kNuwV"};